import { render } from "./index.vue?vue&type=template&id=279f8f91&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./style/index.scss?vue&type=style&index=0&id=279f8f91&lang=scss&scoped=true&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-279f8f91"]])

export default __exports__